import React from "react";

import BusinessScheduleUI from "0.Mine/0.Components/BusinessCard/Hours/UI/BusinessScheduleUI";

import {
  ScheduleState,
  useBusinessScheduleLogicOnboarding,
} from "../../Logic/HoursForm/HoursFormLogic";
interface BusinessScheduleProps {
  setScheduleToParent: (data: ScheduleState) => void;
}

const BusinessScheduleOnboarding = ({ setScheduleToParent }: BusinessScheduleProps) => {
  const {
    schedule,
    vacationStart,
    vacationEnd,
    handleDayToggle,
    handleContinuousToggle,
    handleTimeChange,
    handlePeriodChange,
    handleDateChange,
    submit,
    parseISO,
    format,
  } = useBusinessScheduleLogicOnboarding({ setScheduleToParent });
  return (
    <BusinessScheduleUI
      addEnableButton={false}
      schedule={schedule}
      vacationEnd={vacationEnd}
      vacationStart={vacationStart}
      handleDayToggle={handleDayToggle}
      handleContinuousToggle={handleContinuousToggle}
      handleTimeChange={handleTimeChange}
      handlePeriodChange={handlePeriodChange}
      handleDateChange={handleDateChange}
      submit={submit}
      parseISO={parseISO}
      format={format}
    />
  );
};

export default BusinessScheduleOnboarding;
